import React, { useContext } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { mdiClose, mdiDownload } from "@mdi/js";

import formatRest from "../../../rest/formatRest";

import { Grid } from "../../components/Grid";
import { useInput } from "../../hooks/useInput";
import { Dialog } from "../../containers/Dialog";
import { Button } from "../../components/Button";
import { Spacer } from "../../components/Spacer";
import { DialogBody } from "../../containers/DialogBody";
import { useValidation } from "../../hooks/useValidation";
import { EntryContext } from "../../contexts/EntryContext";
import { DialogFooter } from "../../containers/DialogFooter";
import { SelectSingle } from "../../components/SelectSingle";
import { ValidationContext } from "../../contexts/ValidationContext";

const ContentStyle = styled.div`
    height: 235px;
`;

export const DownloadDialog = props => {
    const { type } = props;

    const validationContext = useContext(ValidationContext);
    const entryContext = useContext(EntryContext);
    const { entry } = entryContext;
    const { calcAreas } = entry.calcSetting;

    const calcArea = useInput("calcArea", calcAreas?.[0] ?? null);

    useValidation(value => {
        if (value.vaxisZ !== 0 && (value.vaxisX !== 0 || value.vaxisY !== 0)) {
            return intl.get("entry.downloadOnlyHorizontalAreasErrorMessage");
        }
        return true;
    }, [calcArea]);

    const downloadWwjson = async () => {
        const allValid = await validationContext.allValid();
        if (allValid) {
            formatRest.downloadWwjson(calcArea.value.id);
        }
    };

    const onDownloadWwmobile = async () => {
        const allValid = await validationContext.allValid();
        if (allValid) {
            formatRest.downloadWwmobile(calcArea.value.id);
        }
    };

    const onDownloadAustriaExcel = async () => {
        const allValid = await validationContext.allValid();
        if (allValid) {
            formatRest.downloadAustriaExcel(entry.id);
        }
    };

    return (
        <Dialog
            width="360px"
            title={intl.get("entry.downloadOptions." + type) + " " + intl.get("common.download")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <ContentStyle>
                    <Grid columns="1">
                        <SelectSingle {...calcArea?.bind}
                            title={intl.get("entry.area")}
                            toLabel={ca => (ca === null ? null : ca.name)}>
                            {calcAreas.filter(ca => ca.name !== "OVERVIEW").map(ca =>
                                <option key={ca.id} value={ca}>{ca.name}</option>
                            )}
                        </SelectSingle>
                    </Grid>
                </ContentStyle>
            </DialogBody>
            <DialogFooter>
                <Button
                    svgIcon={mdiClose}
                    onClick={() => props.onClose()}
                    value={intl.get("common.cancel")} />
                <Spacer variant="vertical" />
                {type === "wwmobil" &&
                    <Button
                        svgIcon={mdiDownload}
                        simulateLoading={true}
                        disabled={calcArea.value === null}
                        onClick={onDownloadWwmobile}
                        value={intl.get("common.download")} />
                }
                {type === "wwjson" &&
                    <Button
                        svgIcon={mdiDownload}
                        simulateLoading={true}
                        disabled={calcArea.value === null}
                        onClick={downloadWwjson}
                        value={intl.get("common.download")} />
                }
                {type === "austriaExcel" &&
                    <Button
                        svgIcon={mdiDownload}
                        simulateLoading={true}
                        onClick={onDownloadAustriaExcel}
                        value={intl.get("common.download")} />
                }
            </DialogFooter>
        </Dialog>
    );
};